<template>
  <generic-historical 
    :get-detalle="getDetalleAux"
    :get-pag="getPagAux"
    :get-excel="getExcelAux"
    :get-params="getParamsAux"
    :get-params-detalle="getParamsDetalleAux"
    :excel-name="ExcelName"
    :id-vista="idVista"
    :header-url="headerUrl"
    :detail-response-path="detailResponsePath"
    :breadcrumbs="breadcrumbs"
    :vuexnamespace="vuexnamespace" />
</template>

<script>
import _ from 'lodash'
import { i18n } from '@/i18n'
import GenericHistorical from '@/views/historical/GenericHistorical.vue'
import { getDistributor } from '@/services/distributors/getDistributor'
import { getHistoricalByDistributor } from '@/services/historical/getHistoricalByDistributor'
import { getHistoricalByDistributorExcel } from '@/services/historical/getHistoricalByDistributorExcel'

export default {
  name: 'list-distributor-historical',
  components: {
    GenericHistorical
  },
  data: function () {
    return {
      idVista: 56,
      vuexnamespace: 'historicalDistributor',
      headerUrl: 'configurations/distributors/details',
      detailResponsePath: 'distribuidor',
      breadcrumbs: [
        { 
          url: 'configurationssa', 
          name: i18n.t('configurations.header') 
        },
        { url: 'configurations/distributors', name: i18n.t('distributors.header') },
        { paths: ['Nombre'] },
      ],
      ExcelName: `${_.kebabCase(i18n.t('distributors.entity_name') + i18n.t('historical.entity_name'))}.xlsx`,
    }
  },
  methods: {
    getParamsAux: function (data) {
      return { idDistribuidor: this.$route.params.id }
    },
    getParamsDetalleAux: function (data) {
      return this.getParamsAux(data)
    },
    getDetalleAux: async function (params) {
      return await getDistributor(params)
    },
    getExcelAux: async function (payload, params) {
      return await getHistoricalByDistributorExcel(payload, params)
    },
    getPagAux: async function (payload, params) {
      return await getHistoricalByDistributor(payload, params)
    },
  }
}
</script>

<style lang="scss" scoped></style>
